var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note note-adder"},[_c('a',{staticClass:"circle add-note",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleCreating($event)}}},[(_vm.creating)?_c('i',{staticClass:"fa fa-minus"}):_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('NoteForm',{directives:[{name:"show",rawName:"v-show",value:(_vm.creating),expression:"creating"}],ref:"form",attrs:{"initialMarkdown":'',"commentsMode":_vm.commentsMode},on:{"save":_vm.onSave,"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./assets/js/components/NoteAdder.vue?vue&type=template&id=03e42f92&
// module id = 143
// module chunks = 0